import styled from "styled-components";

type StyledProps = {
  direction: string;
};

export const StyledDivider = styled.hr<StyledProps>`
  border: none;
  border-left: ${({ theme, direction }) => direction === "verticle" && `1px solid ${theme.default.color.text.light}`};
  height: 1rem;
  width: ${({  direction }) => direction === "horizontal" &&`100%`}; 
  border-bottom: ${({ theme, direction }) => direction === "horizontal" &&`1px solid ${theme.default.color.text.light}`};
  margin: ${({  direction }) =>  direction === "verticle" && "auto 0.4rem" };
`;
